import React from "react";
import {Grid, Link, TextField} from "@material-ui/core";
import {LinkOutlined} from "@material-ui/icons";
import {makeStyles} from "@material-ui/styles";
const useStyles = makeStyles((theme) => ({
  root: {},
  fieldsRow: {
    marginBottom: '12px',
  },
  inputWithAssociationLink: {
    position: 'relative',
  },
  associationLink: {
    position: 'absolute',
    top: '-10px',
    right: '10px',
    cursor: 'pointer',
    decoration: 'none',
    '&:hover': {
      decoration: 'none',
    }
  }
}))

const  RegisteredEmploymentHistoryDisabledFields = (props) => {
  const {attributes} = props;
  const classes = useStyles();
  return (
    <React.Fragment>
      <Grid
        item
        md={3}
        xs={12}
        className={classes.inputWithAssociationLink}
      >
        {attributes.show_company_link ? <Link to='' className={classes.associationLink} onClick={(event) => (console.log(attributes.previous_registration_company_crd_id))}><LinkOutlined/></Link> : ''}
        <TextField
          fullWidth
          disabled
          label="CRD ID"
          name="previous_registration_company_crd_id"
          value={attributes.previous_registration_company_crd_id}
          variant="outlined"
        />
      </Grid>
      <Grid
        item
        md={3}
        xs={12}
        className={classes.inputWithAssociationLink}
      >
        <TextField
          fullWidth
          disabled
          label="Company"
          name="previous_registration_company_name"
          value={attributes.previous_registration_company_name}
          variant="outlined"
        />
      </Grid>
      <Grid
        item
        md={3}
        xs={12}
      >
        <TextField
          fullWidth
          disabled
          label="Start Date"
          name="previous_registration_company_start_date"
          value={attributes.previous_registration_company_start_date}
          variant="outlined"
        />
      </Grid>
      <Grid
        item
        md={3}
        xs={12}
      >
        <TextField
          fullWidth
          disabled
          label="End Date"
          name="previous_registration_company_end_date"
          value={attributes.previous_registration_company_end_date || 'Present'}
          variant="outlined"
        />
      </Grid>
      <Grid
        item
        md={3}
        xs={12}
      >
        <TextField
          fullWidth
          disabled
          label="City"
          name="previous_registration_company_city"
          value={attributes.previous_registration_company_city}
          variant="outlined"
        />
      </Grid>
      <Grid
        item
        md={3}
        xs={12}
      >
        <TextField
          fullWidth
          disabled
          label="State"
          name="previous_registration_company_state"
          value={attributes.previous_registration_company_state}
          variant="outlined"
        />
      </Grid>
    </React.Fragment>
  )
}
export default RegisteredEmploymentHistoryDisabledFields;